import { dtsAPI } from "../../axios";

export const actions = {

    // Track
    GetSingleTrack(context, data) {
        return dtsAPI.get(`Track/${data}`);
    },
    GetDraftTrack(context, data) {
        return dtsAPI.get(`Track/Draft/${data.deliveryUnitId}/${data.departmentId}`);
    },
    GetInProcessTrack(context, data) {
        return dtsAPI.get(`Track/Pending/${data.deliveryUnitId}/${data.departmentId}`);
    },
    GetCompletedTrack(context, data) {
        return dtsAPI.get(`Track/Completed/${data.deliveryUnitId}/${data.departmentId}`);
    },
    GetIncomingTrack(context, data) {
        return dtsAPI.get(`Track/Incoming/${data.deliveryUnitId}/${data.departmentId}`);
    },
    GetReceivedTrack(context, data) {
        return dtsAPI.get(`Track/Pending/Action/${data.deliveryUnitId}/${data.departmentId}`);
    },
    GetProcessedTrack(context, data) {
        return dtsAPI.post(`Track/Processed/${data.deliveryUnitId}/${data.departmentId}`, data);
    },
    GetTrackByReferenceNumber(context, data) {
        return dtsAPI.post(`Track/ReferenceNumber/${data.deliveryUnitId}`, data);
    },
    GetTrackByProcessTypeId(context, data) {
        return dtsAPI.get(`Track/ProcessType/${data.processTypeId}/${data.deliveryUnitId}/${data.departmentId}`);
    },
    GetTrackBySearch(context, data) {
        return dtsAPI.post(`Track/Search`, data);
    },
    GetTrackTimeline(context, data) {
        return dtsAPI.get(`Track/Timeline/${data}`);
    },
    GetTrackLogs(context, data) {
        return dtsAPI.get(`Track/Logs/${data}`);
    },
    GetTrackChild(context, data) {
        return dtsAPI.get(`Track/Child/${data}`);
    },
    UpdateTrack(context, data) {
        return dtsAPI.put(`Track/${data.id}`, data);
    },
    DeleteTrack(context, data) {
        return dtsAPI.delete(`Track/${data}`);
    },
    CreateTrack(context, data) {
        return dtsAPI.post(`Track/${data.deliveryUnitId}/${data.departmentId}`, data);
    },
    ChildTrack(context, data) {
        return dtsAPI.post(`Track/Child/${data.deliveryUnitId}/${data.departmentId}/${data.parentId}`, data);
    },
    ForwardTrack(context, data) {
        return dtsAPI.post(`Track/Forward/${data.parentId}/${data.deliveryUnitId}/${data.departmentId}`, data);
    },
    MergeTrack(context, data) {
        return dtsAPI.post(`Track/Merge/${data.parentId}`, data.array);
    },
    PostTrack(context, data) {
        return dtsAPI.post(`Track/Post/${data}`);
    },
    UnsendTrack(context, data) {
        return dtsAPI.post(`Track/UnSend/${data}`);
    },
    ReceiveTrack(context, data) {
        return dtsAPI.post(`Track/Receive/${data.id}/${data.deliveryUnitId}/${data.departmentId}`);
    },
    ReturnTrack(context, data) {
        return dtsAPI.post(`Track/Return/${data.id}/${data.deliveryUnitId}/${data.departmentId}`, data);
    },
    CompleteTrack(context, data) {
        return dtsAPI.post(`Track/Complete/${data.id}/${data.deliveryUnitId}/${data.departmentId}`, data);
    },
    UpdateNotes(context, data) {
        return dtsAPI.put(`Track/Note/${data.id}`, data);
    },
    GetIncomingTrackCount(context, data) {
        return dtsAPI.get(`Track/Incoming/Count/${data.deliveryUnitId}/${data.departmentId}`);
    },
    GetDashboardData(context, data) {
        return dtsAPI.get(`Dashboard/${data.deliveryUnitId}/${data.departmentId}`);
    },
    GetTrackStats(context, data) {
        return dtsAPI.post(`Track/Stats/${data.campusId}`, data);
    },

    // Track Summary
    async GetTrackSummaryGroupedByCampus(context, data) {
        return dtsAPI.post(`TrackSummary/Campus`, data);
    },
    async GetTrackSummaryGroupedByCampusAndProcessType(context, data) {
        return dtsAPI.post(`TrackSummary/Campus/ProcessType/${data.campusId}`, data);
    },
    async GetTrackSummaryGroupedByDU(context, data) {
        return dtsAPI.post(`TrackSummary/DeliveryUnit/${data.campusId}`, data);
    },
    async GetTrackSummaryGroupedByDUAndProcessType(context, data) {
        return dtsAPI.post(`TrackSummary/DeliveryUnit/ProcessType/${data.campusId}`, data);
    },
}